'use client';

import s from 'Workadabra/app/[lang]/home/sections/final-cta/styles.module.css';
import { rdBecomeProvider, rdCtaProviderBody, rdCtaProviderTitle, rdCtaSeekerBody, rdCtaSeekerTitle, rdFindService } from 'Workadabra/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? '#';

const ArrowIcon = () => (
  <svg aria-hidden='true' fill='none' height={17} viewBox='0 0 24 24' width={17} xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 12h14M13 6l6 6-6 6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
  </svg>
);

export const FinalCtaSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  return (
    <section className={s.root} data-testid='final-cta-section' id='final-cta'>
      <div className={s.brick}>
        <div className={`${s.half} ${s.halfLeft}`} data-testid='final-cta-seeker'>
          <div className={s.inner}>
            <h3 className={s.title}>{rdCtaSeekerTitle[language]}</h3>
            <p className={s.body}>{rdCtaSeekerBody[language]}</p>
            <a className={s.cta} data-testid='final-cta-seeker-link' href={APP_URL}>
              {rdFindService[language]}
              <ArrowIcon />
            </a>
          </div>
        </div>
        <div className={`${s.half} ${s.halfRight}`} data-testid='final-cta-provider'>
          <div className={s.inner}>
            <h3 className={s.title}>{rdCtaProviderTitle[language]}</h3>
            <p className={s.body}>{rdCtaProviderBody[language]}</p>
            <a className={s.cta} data-testid='final-cta-provider-link' href={APP_URL}>
              {rdBecomeProvider[language]}
              <ArrowIcon />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
